import $ from 'jquery'
import { toolkitUrls } from '@/links'
import { defaultMemoryCache, ajaxCacheWrapper } from './cache'

export { getToolkitStandards }

/*
  options include: {
    substandards: true,
    vertical_progressions: true,
    horizontal_progressions: true
  }
*/
function getToolkitStandards(setCode, standardRefs, options) {
  if (!options) {
    options = {}
  }
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/standards/${setCode.toLowerCase()}/long_refs`,
    method: 'GET',
    dataType: 'json',
    data: $.param({ list: standardRefs.join(','), ...options })
  }).then(result => {
    // sort list of standards in order of the standardRefs provided
    let standardsMap = {}
    result.standards.forEach(standard => {
      standardsMap[standard.standard_long_ref] = standard
    })
    result.standards = standardRefs.map(ref => standardsMap[ref])
    return result
  })
}
